import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'latency-campaign/create',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./LatencyCampaignCreate').default
      callback(null, component)
    }, 'LatencyCampaignCreate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/LatencyCampaignCreate/index.js